import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Faktura',
  type: 'object',
  properties: {
    number: {
      title: 'Numer faktury',
      type: 'string',
      fieldRequired: true
    },
    price: {
      title: 'Kwota faktury',
      type: 'number',
      fieldRequired: true
    },
    priceToPay: {
      title: 'Kwota do wypłaty',
      type: 'number',
      fieldRequired: true,
      maximum: 'this.price',
      warnings: {
        maximum: '$external.maxToPay',
        warningMessages: {
          maximum: 'Uwaga: Kwota dotacji na bieżący miesiąc zostanie przekroczona.'
        }
      }
    }
  },
  allOf: [validationMessages]
};
